import { render } from "./Relogin.vue?vue&type=template&id=3cd805da&scoped=true"
import script from "./Relogin.vue?vue&type=script&lang=js"
export * from "./Relogin.vue?vue&type=script&lang=js"

import "./Relogin.vue?vue&type=style&index=0&id=3cd805da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd805da"]])

export default __exports__